import { Button } from "primereact/button";
import { Message } from "primereact/message";

import {
  INetworkStatusOverride,
  IOutOfNetworkException,
  buildNetworkStatusMessage,
  buildOutOfNetworkExceptionMessage,
  canApproveOutOfNetworkException,
} from "../../../eligibilityMessages";
import { requestOutOfNetworkException } from "../../../outOfNetworkExceptionEvent";

/**
 * CLE-2683 / CLE-2882 / CLE-2883 — the network-status notice under the benefit fields, rendered in both the
 * primary and secondary panels from the stored eligibility response, so a reopened order shows the same
 * thing as a fresh check.
 *
 *   · out of network, figures shown      → warning, no button
 *   · out of network, nothing to show    → warning + "Exception is approved" where the API allows it
 *   · exception approved                 → info message, no warning, no button
 *
 * The button re-runs eligibility for this side with `outOfNetworkExceptionApproved: true`
 * (`EligibilityButton` listens for the request). Undo is the normal Run Eligibility button.
 */
export function NetworkStatusBanner({
  networkStatusOverride,
  outOfNetworkException,
  isSecondaryInsurance = false,
}: {
  networkStatusOverride?: INetworkStatusOverride | null;
  outOfNetworkException?: IOutOfNetworkException | null;
  isSecondaryInsurance?: boolean;
}) {
  const exceptionMessage = buildOutOfNetworkExceptionMessage(
    outOfNetworkException
  );
  const networkMessage = buildNetworkStatusMessage(networkStatusOverride);
  const canApprove = canApproveOutOfNetworkException(networkStatusOverride);

  return (
    <>
      {exceptionMessage && (
        <Message severity="info" className="mt-2" text={exceptionMessage} />
      )}
      {networkMessage && (
        <div className="mt-2 flex flex-column align-items-start gap-2">
          <Message severity="warn" text={networkMessage} />
          {canApprove && (
            <Button
              type="button"
              label="Exception is approved"
              icon="pi pi-check"
              className="p-button-sm p-button-outlined"
              onClick={() => requestOutOfNetworkException(isSecondaryInsurance)}
            />
          )}
        </div>
      )}
    </>
  );
}
